// eslint-disable-next-line import/prefer-default-export
export const events = state => state.events.data;

export const total = state => state.events.total;
